import { render } from "./ScoreBar.vue?vue&type=template&id=19f007ba&scoped=true"
import script from "./ScoreBar.vue?vue&type=script&lang=js"
export * from "./ScoreBar.vue?vue&type=script&lang=js"

import "./ScoreBar.vue?vue&type=style&index=0&id=19f007ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19f007ba"]])

export default __exports__